import { GUI } from 'lil-gui'
import * as THREE from 'three';
import { Main } from '../main/Main';
import { Params } from './Params';
import Stats from 'three/examples/jsm/libs/stats.module'
import { MojisLines } from '../moji/MojisLines';
import { LogoMark } from '../moji/logo/LogoMark';
import { DomControl } from '../main/DomControl';





export class DataManager {

    private static instance: DataManager;
    
    public gui:GUI;
    public isSp:boolean;
    public aspectHW:number=1;//height/width
    public mouseX:number=0;
    public mouseY:number=0;
    public isTouch:boolean=false;
    public domElement:HTMLElement;
    public scene:THREE.Scene;
    public logo :THREE.Mesh;
    public logo2:THREE.Mesh;
    public logoMark:LogoMark;
    public mojis:MojisLines;
    public camera:THREE.OrthographicCamera;
    public dom:DomControl;
    public stats:Stats;
    public isFocus:boolean=true;
    private isInit:boolean=false;


    /**
     * The Singleton's constructor should always be private to prevent direct
     * construction calls with the `new` operator.
     */
    private constructor() { }

    public init(){

        if(this.isInit) return;
        this.isInit=true;

        //this.main = m;

        //if( window.location.search == "?debug" ){
            this.gui = new GUI();
            this.stats = Stats();
            document.body.appendChild(this.stats.domElement);
        //}

        this.gui?.close();
        
        //this.domElement = this.main.renderer.domElement;
        this.gui?.add(window,"innerHeight").listen();

        this.gui?.add(this,"mouseX").listen();
        this.gui?.add(this,"mouseY").listen();
        this.gui?.add(this,"isTouch").listen();

        //隠す
        if(this.gui){
            this.gui.domElement.style.display="none";
            this.stats.domElement.style.display="none";
        }

        this.isSp = this.isSmartPhone();

        if(!this.isSp){
            //PC
            window.onmousemove = (event)=>{
                this.mouseX = event.clientX;
                this.mouseY = event.clientY;
            }
            document.addEventListener('keydown', (event) => {
                const keyName = event.key;
                if(keyName=="d"){
                    if(this.gui){
                        if(this.gui.domElement.style.display=="none"){
                            this.gui.domElement.style.display="block";
                            this.stats.domElement.style.display="block";
                        }else{
                            this.gui.domElement.style.display="none";
                            this.stats.domElement.style.display="none";
                        }    
                    }
                }
            });



        }else{

            window.addEventListener("touchstart", 
                (event)=>{
                    this.isTouch=true;
                    this.mouseX = event.touches[0].clientX;
                    this.mouseY = event.touches[0].clientY;//-window.scrollY;
                }
            )
            /*
            window.addEventListener("touchend", 
                (event)=>{
                    this.isTouch=false;
                    this.mouseX = event.touches[0].clientX;
                    this.mouseY = event.touches[0].clientY;//-window.scrollY;
                }
            )*/

        }

        
        //ここ
        // ウィンドウをフォーカスしたら指定した関数を実行
        window.addEventListener('focus', ()=>{
            console.log('onFocus');
            this.isFocus=true;
        }, false);

        // ウィンドウからフォーカスが外れたら指定した関数を実行
        window.addEventListener('blur', ()=>{
            console.log("onBlur");
            this.isFocus=false;
        }, false);
        
    }






    public addScene(o:THREE.Object3D){   
        this.scene.add(o);
    }

    private isSmartPhone():boolean {
        if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            return true;
        } else {
            return false;
        }
    }



    public update(){
        this.stats?.update();
    }

    public IsTopMode():boolean{
        return document.getElementById("mvScript").dataset.mode=="top";
    }

    /**
     * The static method that controls the access to the singleton instance.
     *
     * This implementation let you subclass the Singleton class while keeping
     * just one instance of each subclass around.
     */
    public static getInstance(): DataManager {
        if (!DataManager.instance) {
            DataManager.instance = new DataManager();
            //DataManager.instance.init();
        }

        return DataManager.instance;
    }

}